// extracted by mini-css-extract-plugin
export default {"container":"XqiZIyLz_1tMLC4TIbUG","text":"TblnwkEBRQDQQNcINAiw","title":"M8auJG_RC10G613OVpZa","imgEmpty":"ovcIPIurjv_uS3OsdfzH"};